// Frontend-only color mapping for product stages
export const stageConfig: Record<string, { color: 'default' | 'primary' | 'success' | 'warning' }> =
  {
    IDEA: { color: 'default' },
    POC: { color: 'warning' },
    MVP: { color: 'primary' },
    ADVANCED: { color: 'success' },
  }
